// extracted by mini-css-extract-plugin
export default {"heading":"Dynamic_heading__RTlT4","unorderList":"Dynamic_unorderList__nWOnw","buttonLikeDiv":"Dynamic_buttonLikeDiv__w7Az-"};